// @ts-nocheck
/**
 * Wrapper for lucide-react icons that have a type-resolution issue
 * with this version (v0.575) under TypeScript bundler resolution.
 *
 * The icons exist in the runtime export and in the .d.ts declarations,
 * but the bundler's moduleResolution does not pick them up correctly.
 *
 * Importing them through this file with @ts-nocheck bypasses the false
 * positive while keeping full runtime functionality.
 *
 * Use this file ONLY for icons that fail to type-check with direct import.
 * Icons that work normally (Mail, Calendar, ArrowRight, etc.) keep using
 * the standard `from 'lucide-react'` import.
 */

export {
  Smartphone,
  Star,
  Quote,
  Wallet,
  Hash,
  Slack,
  Headset,
  Wrench,
  ListChecks,
  Link2,
  Image as ImageIcon,
  MessageSquarePlus,
  LifeBuoy,
  Headphones,
} from 'lucide-react'
